import React from 'react';
import { motion } from 'framer-motion';
import { Search, Megaphone, Share2, Mail, BarChart3 } from 'lucide-react';
const services = [{
  icon: Search,
  title: 'SEO',
  description: 'Show up where real boat buyers search. Our SEO brings in higher-intent traffic and consistently boosts organic leads that turn into sales.'
}, {
  icon: Megaphone,
  title: 'Paid Advertising',
  description: 'Need buyers now? Our PPC targets active boat shoppers and brings past visitors back — driving more calls, more form fills, and consistently delivering an average 3–5x return on ad spend.'
}, {
  icon: Share2,
  title: 'Social Media Marketing',
  description: 'Stay top-of-mind while buyers research, browse, and compare. We create content that builds trust and keeps your dealership in their feed.'
}, {
  icon: Mail,
  title: 'Email Marketing',
  description: 'Send the right message at the right moment. With targeted messaging and automated follow-ups, we help you turn more leads into scheduled appointments and sold boats.'
}, {
  icon: BarChart3,
  title: 'Conversion Rate Optimization',
  description: "More traffic means nothing if visitors don't convert. We analyze behavior, remove friction, and help more visitors convert into real leads."
}];
export function ServicesSection() {
  return <section className="py-24 bg-[#0A1628] relative overflow-hidden" data-id="element-87">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-88">
        <div className="absolute -right-20 top-20 w-96 h-96 rounded-full bg-[#D4AF37] blur-3xl" data-id="element-89"></div>
        <div className="absolute -left-20 bottom-20 w-96 h-96 rounded-full bg-blue-500 blur-3xl" data-id="element-90"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-91">
        <div className="text-center mb-16" data-id="element-92">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 font-playfair" data-id="element-93">
            What We Do
          </h2>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto" data-id="element-94"></div>
        </div>

        <div className="flex flex-wrap justify-center gap-8" data-id="element-95">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white/5 backdrop-blur-sm p-8 rounded-xl border border-white/10 hover:border-[#D4AF37]/50 transition-all duration-300 group w-full md:w-[calc(50%-1rem)] lg:w-[calc(33.333%-1.34rem)]" data-id="element-96">
              <div className="w-14 h-14 bg-[#D4AF37]/20 rounded-full flex items-center justify-center mb-6 group-hover:bg-[#D4AF37] transition-colors duration-300" data-id="element-97">
                <service.icon className="w-7 h-7 text-[#D4AF37] group-hover:text-white transition-colors duration-300" data-id="element-98" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4 font-playfair" data-id="element-99">
                {service.title}
              </h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-100">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}